export default "__VITE_ASSET__3f11b686__"